<template>
  <v-container
    fluid
    fill-height
    class="psTable p4-report"
  >     
    <v-row>
      <v-col
        xs="3"
        sm="3"
        md="2"
        lg="2"
      >
        <psReportHeader
          id="filter"
          ref="clientHeader"
          :show-save-button="false"
          :show-refresh-button="false"
          :header-title="$t('Clients')"
          :show-search-bar="true"
          :show-add-button="false"
          @search-event="clientSearchEvent"
          @save-event="saveData"
          @refresh-event="refreshEvent"               
        />
        <ps-table
          ref="clientTable"
          class="clientTable"
          :data="allClients"
          :options="clientOptions"
          :filter-string="clientSearch"
        />
      </v-col>
      <v-col
        xs="9"
        sm="9"
        md="10"
        lg="10"
        class="userFlex"
      >
        <div class="userContainer">
          <psReportHeader
            id="filter"
            ref="userHeader"
            :header-title="clientName"
            :show-search-bar="true"
            :show-add-button="true"
            @search-event="userSearchEvent"
            @save-event="saveData"
            @refresh-event="refreshEvent"
            @add-event="showAddUserDialog"
          />
          <ps-table
            ref="userTable"
            class="userTable table-striped"
            :data="allUsers"
            :options="options"
            :filter-string="userSearch"
          />
          <div style="width:100%; border-top: 0.0625em solid #C0C0C0;">
            <span class="icon-profitsword-24 smallIco" /> ProfitSage&nbsp;&nbsp;
            <span class="icon-lock-24 smallIco" /> Change Password &nbsp;&nbsp;
            <span class="icon-smartphone-24 smallIco" /> Mobile &nbsp;&nbsp;
            <span class="icon-swap_horiz-24 smallIco" /> PS-Imports Admin &nbsp;&nbsp;
            <span class="icon-security-24 smallIco" /> PS-Authenticate Admin
          </div>              
        </div>
      </v-col>  
    </v-row> 
       
    <newUserDialog
      ref="newUserDialog"  
      v-model="AddUserDialogVisibility"       
      :ps-client-guid="clientGuid"
      @userAdded="refreshData"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import newUserDialog from "./NewUserDialog";

var addedRows = [];
var editedRows = [];

export default {
    name: "PsUserAdmin",
    components:{ newUserDialog},
    data() {
        return {

            AddUserDialogVisibility:false,
            clientName: "ProfitSword Users",
            clientGuid:"05a5ab9b-8579-4509-1234-61c778b62d5e",
            isHidden: false,
            switch1: true,
            absolute: false,
            dialog: false,
            zIndex: 5,
            options: {
                //index: "psClientId", // To do: need an Index field.
                resizableColumns: true,
                history: true,
                //addRowPos: "top",
                height: "76vh",
                movableColumns: true,
                pagination: "local",
                paginationSize: 30,
                paginationAddRow: "table",
                //paginationAddRow:"page",
                paginationSizeSelector: [3, 6, 8, 30],

                cellEdited: cell => {
                    cell._cell.edited = true;
                    var editedRow = cell.getRow();
                    editedRow._row.data.edited = true;
                    this.setRowCondition(editedRow);
                },
                // rowSelected: row => {                   
                //   this.allUsers[row.getPosition()].markedForDeletion = true;
                //   this.setRowDeleteCondition(row);
                //},
                // rowDeselected: row => {
                //  this.allUsers[row.getPosition()].markedForDeletion = false;
                //  this.setRowUnDeleteCondition(row);
                // },
                columns: [
                    {
                        formatter: this.deleteIcon,
                        headerSort: false,
                        width: 50,
                        align: "center",
                        cellClick: function(e, cell) {
                            cell.getRow().toggleSelect();
                        }
                    },       
                    {
                        formatter: this.userLockoutFormater,
                        headerSort: false,
                        width: 50,
                        align: "center",
                        field: "userLockedOut",
                        cellClick: (e, cell) => {
                            this.UnlockUser(cell.getRow());
                        }                        
                    },  
                    {                
                        formatter: this.mfaFormatter,                
                        field: "resetMfaSecret",
                        title: "MFA Reset",
                        width: 100,                               
                        editor: "button",
                        headerSort: false,
                        resizableColumns:false,
                        cellClick: (e, cell) => {
                            this.toggleActive(cell);
                        }
                    },          
                    {                
                        formatter: this.mfaFormatter,                
                        field: "mfaEnabled",
                        title: "MFA Enabled?",
                        width: 125,                               
                        editor: "button",
                        headerSort: false,
                        resizableColumns:false,
                        cellClick: (e, cell) => {
                            this.toggleActive(cell);
                        }
                    },          
                    {
                        formatter: this.cellFormatter,
                        title: "Username",
                        field: "userName",
                        width: 200,
                        editor: "input"
                    },
                    {
                        formatter: this.cellFormatter,
                        title: "First",
                        field: "firstName",
                        width: 154,
                        editor: "input"
                    },
                    {
                        formatter: this.cellFormatter,
                        title: "Last",
                        field: "lastName",
                        width: 200,
                        editor: "input"
                    },
                    {
                        formatter: this.cellFormatter,
                        title: "Email",
                        field: "email",
                        width: 200,
                        editor: "input"
                    },


                    {   
                        formatter: this.profitsageScopeFormatter,
                        field: "scopes",
                        width: 50,                                                                    
                        headerSort: false,
                        resizableColumns:false,
                        cellClick: (e, cell) => {
                            this.toggleScope(cell,"ProfitSageApi");
                        }
                    },
                    {                
                        formatter: this.chgPassScopeFormatter,                
                        field: "scopes",
                        width: 50,                               
                        editor: "button",
                        headerSort: false,
                        resizableColumns:false,
                        cellClick: (e, cell) => {
                            this.toggleScope(cell,"ChgPass");
                        }
                    },                   
                    {                                
                        formatter: this.mobileScopeFormatter,
                        field: "scopes",
                        width: 50,                               
                        editor: "button",
                        headerSort: false,
                        resizableColumns:false,
                        cellClick: (e, cell) => {
                            this.toggleScope(cell,"PSMobile");
                        }
                    },
                    {                                
                        formatter: this.psImportsScopeFormatter,
                        field: "scopes",
                        width: 50,                               
                        headerSort: false,
                        resizableColumns:false,
                        cellClick: (e, cell) => {
                            this.toggleScope(cell,"PSImports");
                        }
                    },
                    {                                
                        formatter: this.psAuthenticateScopeFormatter,
                        field: "scopes",
                        width: 50,                               
                        headerSort: false,
                        resizableColumns:false,
                        cellClick: (e, cell) => {
                            this.toggleScope(cell,"PSAuthenticate");
                        }
                    },     
                    {                                
                        formatter: this.activeFormatter,
                        title: "Active",
                        field: "isActive",
                        width: 80,                                                      
                        headerSort: true,
                        resizableColumns:false,
                        cellClick: (e, cell) => {
                            this.toggleActive(cell);
                        }
                    },               
                    {
                        formatter: this.cellFormatter,
                        title: "Last Login",
                        field: "lastLogin",
                                              
                    },
                    {
                        formatter: this.cellFormatter,
                        title: "Global ID",
                        name: "userGuid",
                        field: "guid",
                        ID: "userGuid"
                                                
                    },
                    
                ]
            },            
            clientOptions: {
                layout: "fitColumns",
                resizableColumns: false,
                height: "42em",
                movableColumns: false,
                renderComplete: () => { 
                    this.jumpToAndSelectRow("ProfitSword");
                },
                rowAdded: function(row) {
                    row._row.data.edited = false;
                    addedRows.push(row);
                    // var currentHeight = parseInt(this.options.height.replace("vh", ""));
                    // var newHeight = currentHeight + 6;
                    // this.setHeight(newHeight + "vh");
                    row.scrollTo();
                    this.navigateNext();
                },
                cellEdited: function(cell) {
                    var row = cell.getRow();
                    row._row.data.edited = true;
                    var rowCount = row._row.parent.activeRowsCount;
                    var currentRowPosition = row.getPosition();

                    if (currentRowPosition + 1 == rowCount) {
                        this.addRow({}).then(function(r) {});
                    }
                },
                columns: [
                    ,
                    {
                        title: "",
                        field: "psClientName",
                        headerSort: false,
                        cellClick: (e, cell) => {
                            var row = cell.getRow();
                            this.selectClientRow(row);
                        }
                    }
                ]
            },
            userSearch: "",
            clientSearch: ""
        };
    },
    computed: {
        ...mapGetters(["allUsers", "allClients"])
    },
    created() {
        window.Bus.$off("UserAdded");
        window.Bus.$off("UserUpdated");
        window.Bus.$off("UserDeleted");
        window.Bus.$off("UserUnlocked");
       
        this.fetchUsers(this.clientGuid);
        this.clientName = this.clientName;
        this.fetchClients();
        window.Bus.$on("UserAdded", () => {
            this.refreshData();
        });
        window.Bus.$on("UserUpdated", () => {
            this.fetchUsers(this.clientGuid);
            // this.refreshData();
        });
        window.Bus.$on("UserDeleted", () => {
            this.refreshData();
        });

        window.Bus.$on("UserUnlocked", () => {
            alert("User Unlocked");
            this.refreshData();
        });
    },
    mounted() {},
    methods: {
        ...mapActions(["fetchUsers", "updateUsers", "fetchClients","deleteUser","unlockUser"]),
        ...mapMutations(["setUsers", "setClients"]),
        refreshEvent() {
            this.refreshData();
        },
        navigateNext() {
            var table = this.$refs.addRowTable.$refs.tabulator.getInstance();
            var row = table.getRowFromPosition(0, true);
            var cell = row.getCells()[1];
            cell.edit(true);
        },
        selectClientRow(row) {
            var table = this.$refs.clientTable.$refs.tabulator.getInstance();
            table.deselectRow();
            row.select();

            this.clientName= row._row.data.psClientName + " Users";
            this.clientGuid=row._row.data.psClientGuid;

            // this.setUsers([]);
            // this.fetchUsers(row._row.data.psClientGuid);
            // var table = this.$refs.userTable.$refs.tabulator.getInstance();
            // table.clearData();
            // table.setData(this.allUsers);
            // this.clientName = row._row.data.psClientName + " Users";

            this.refreshData();
        },
        jumpToAndSelectRow(cellValue){
            var table = this.$refs.clientTable.$refs.tabulator.getInstance();
            if(table.rowManager != null){
                var row = table.getRows().find(r => r._row.data.psClientName === cellValue);
                row.scrollTo();
                row.select();
            }
        },
       
        deleteSelectedUsers() {
            var table = this.$refs.userTable.$refs.tabulator.getInstance();
            var selectedRows = table.getSelectedRows();
           
            var delFunction = this.deleteUser; // cant access 'this' in foreach.
            selectedRows.forEach(function(r) {                               
                delFunction(r.getData()["guid"]);         
            });
        },        
        setRowCondition(row) {
            var currentRowPosition = row.getPosition();
            this.allUsers[currentRowPosition].changed = true;
        },
        setRowDeleteCondition(row) {
            var currentRowPosition = row.getPosition();
            this.allUsers[currentRowPosition].markedForDeletion = true;
        },
        setRowUnDeleteCondition(row) {
            var currentRowPosition = row.getPosition();
            this.allUsers[currentRowPosition].markedForDeletion = false;
        },
        refreshData() {
            this.setUsers([]);
            this.fetchUsers(this.clientGuid);
      
        },
        userSearchEvent(val) {
            this.userSearch = val;
        },
        clientSearchEvent(val) {
            this.clientSearch = val;
        },
        saveData() {            
            //alert("saving users");
            this.updateUsers().then(()=>{               
                this.refreshData();
            });

            //Delete Selected rows
            this.deleteSelectedUsers();

        },
        checkBoxFormatter(cell, formatterParams, onRendered) {
            var row = cell.getRow();
            if (row._row.data.psClientId == -1) {
                return cell.getValue() == true
                    ? "<input type=\"checkbox\" checked tabindex=\"0\"/>"
                    : "<input type=\"checkbox\" tabindex=\"0\"/>";
            }
            var oldValue = cell._cell.oldValue;

            if (oldValue != null && oldValue != cell.getValue()) {
                cell.getElement().style.border = "0.0625em solid red";
            }

            return cell.getValue() == true
                ? "<input type=\"checkbox\" checked tabindex=\"0\" />"
                : "<input type=\"checkbox\" tabindex=\"0\" />";
        },
        cellFormatter(cell, formatterParams, onRendered) {
            var row = cell.getRow();
            if (row._row.data.psClientId == -1) return cell.getValue();

            var oldValue = cell._cell.oldValue;

            if (oldValue != null && oldValue != cell.getValue()) {
                cell.getElement().style.border = "0.0625em solid red";
            }
            return cell.getValue();
        },
        deleteIcon() {
            return "<span class='icon-trash-24 largeIco'></span></i>";
        },
        userLockoutFormater(cell){
            if(cell.getValue()==undefined){
                cell.getElement().style.color = "#DDDDDD"; 
                return;
            }
                
            if(cell.getValue())
                cell.getElement().style.color = "#FF0000";
            else
                cell.getElement().style.color = "#DDDDDD"; 
            return "<span class='icon-lock-24 largeIco' title='Unlock user'></span></i>";
        },
        profitsageScopeFormatter(cell) {
            this.formatImageButton(cell,"ProfitSageApi");
            return "<span  class='icon-profitsword-24 largeIco'  title='ProfitSage'></span></i>";
        },
        chgPassScopeFormatter(cell) {
            this.formatImageButton(cell,"ChgPass");
            return "<span class='icon-lock-24 largeIco' title='Change Password'></span></i>";
        },
        mfaFormatter(cell) {
            cell.getElement().style.color = cell.getValue() ?  "#003F64" : "#DDDDDD";
            const iconClass = cell.getColumn().getField() === "resetMfaSecret" ? "icon-pw_reset" : "icon-check-24";
            return "<span class='" + iconClass + " largeIco' title='Require Re-register MFA'></span></i>";
        },
        mobileScopeFormatter(cell) {
            this.formatImageButton(cell,"PSMobile");
            return "<span  class='icon-smartphone-24 largeIco' title='Mobile'></span></i>";
        },
        psImportsScopeFormatter(cell) {
            this.formatImageButton(cell,"PSImports");
            return "<span  class='icon-swap_horiz-24 largeIco' title='PS-Imports Admin'></span></i>";
        },
        psAuthenticateScopeFormatter(cell) {
            this.formatImageButton(cell,"PSAuthenticate");
            return "<span class='icon-security-24 largeIco'  title='PS-Authenticate Admin'></span></i>";       
        },
        activeFormatter(cell) {
            if(cell.getValue()==undefined){
                cell.getElement().style.color = "red"; 
                return "<span class='icon-close-24 largeIco' title='Unlock user'></span></i>"; 
            }
                
            if(cell.getValue()){
                cell.getElement().style.color = "#003F64"; 
                return "<span class='icon-check-24 largeIco' title='Unlock user'></span></i>"; 
            }
            else{
                cell.getElement().style.color = "red"; 
                return "<span class='icon-close-24 largeIco' title='Unlock user'></span></i>"; 
            }
        },
        showAddUserDialog() {
            this.AddUserDialogVisibility=true;  
            this.$refs.newUserDialog.clearForm();
            setTimeout(() => {                
                this.$refs.newUserDialog.setFocus();  
            }, 300);                   
        },
        saveNewRows() {
            var addRowTable = this.$refs.addRowTable.$refs.tabulator.getInstance();
            var newRows = addRowTable.getRows();
            var userTable = this.$refs.userTable.$refs.tabulator.getInstance();
            var sorters = userTable.getSorters();

            userTable.clearSort();

            newRows.forEach(r => {
                if (r._row.data.edited == true) {
                    r._row.data.created = true;
                    userTable
                        .addData(Object.assign({}, r._row.data), true)
                        .then(function(row) {});
                }
            });
            addRowTable.clearData();

            addRowTable.addRow({ psClientName: "" }).then(function(row) {
                row.scrollTo();
                var cells = row.getCells();
                cells[1].edit(true);
            });

            this.setUsers(userTable.getData());
            this.dialog = false;
        },
        toggleScope(cell,scopeName){  
            
            if(cell.getValue().includes(scopeName))
                cell.getValue().splice(cell.getValue().indexOf(scopeName),1);
            else
                cell.getValue().push(scopeName);
                
            this.setRowCondition(cell.getRow());

            this.formatImageButton(cell,scopeName);       
            cell.getElement().style.border ="1px solid red";     
            //cell.getRow().edited=true;      
        },
        toggleActive(cell){  
            cell.setValue(!cell.getValue());
            cell.getElement().style.border ="1px solid red";     
        },
        UnlockUser(row){  
            if(row._row.data.userLockedOut)            
                this.unlockUser(row._row.data.guid);
        },
        formatImageButton(cell,scopeName){
            if(cell.getValue()==undefined){
                cell.getElement().style.color = "#DDDDDD"; 
                return;
            }
                
            if(cell.getValue().includes(scopeName))
                cell.getElement().style.color = "#003F64";
            else
                cell.getElement().style.color = "#DDDDDD"; 
             
        }
    }
};
</script>

<style lang='scss'>
@import "../styles/UserAdmin.scss";
.smallIco{
    font-size: 1.1em;
}
.largeIco{
    font-size: 1.2em;    
}
</style>